import { render, staticRenderFns } from "./Stackedbar.vue?vue&type=template&id=48db9978&"
import script from "./Stackedbar.vue?vue&type=script&lang=js&"
export * from "./Stackedbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports